import { environment } from "src/environments/environment";

interface Scripts {
    name: string;
    src: string;
}

export const ScriptStore: Scripts[] = [
    {
        name: 'remita_inline',
        src: environment.production ? 'https://login.remita.net/payment/v1/remita-pay-inline.bundle.js' : 'https://login.remita.net/payment/v1/remita-pay-inline.bundle.js',
    },
    {
        name: 'switch_inline',
        src: environment.production ? 'https://newwebpay.interswitchng.com/inline-checkout.js' : 'https://newwebpay-sandbox.interswitchng.com/inline-checkout.js',
    },
];
